export const QUESTION_TYPES = {
  singleCorrectAnswer: "singleCorrectAnswer",
  multipleCorrectAnswer: "multipleCorrectAnswer",
};
